const map = {
	"./CustomObject/HomeArticle": 4689,
	"./CustomObject/HomeArticle.js": 4689,
	"./CustomObject/HomeContact": 3815,
	"./CustomObject/HomeContact.js": 3815,
	"./CustomObject/HomeEvent": 2107,
	"./CustomObject/HomeEvent.js": 2107,
	"./CustomSetup/Class": 8390,
	"./CustomSetup/Class.js": 8390,
	"./CustomSetup/Client": 891,
	"./CustomSetup/Client.js": 891,
	"./CustomSetup/SlidePrimary": 6581,
	"./CustomSetup/SlidePrimary.js": 6581,
	"./CustomSetup/SlideSecondary": 1041,
	"./CustomSetup/SlideSecondary.js": 1041,
	"./CustomSetup/Trainer": 8559,
	"./CustomSetup/Trainer.js": 8559
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8570;